import React, { useEffect, useState } from 'react'
import UploadDocument from 'components/global/UploadDocument'
import { Input } from 'antd'
import { Photo } from 'types/globalTypes'
import { creationEventStore } from 'state/event/eventCreationStore'

const CoverAndDescription = () => {
  const [documentIds, setDocumentIds] = useState<string[]>()
  // const [description, setDescription] = useState<string | undefined>()
  const [photos, setPhotos] = useState<Photo[]>()

  const { setCoverPhotoIds, setDescription, eventData, description } =
    creationEventStore(store => ({
      coverPhotoIds: store.coverPhotoIds,
      setCoverPhotoIds: store.setCoverPhotoIds,
      description: store.description,
      setDescription: store.setDescription,
      eventData: store.eventData,
    }))

  useEffect(() => {
    setCoverPhotoIds(documentIds)
  }, [documentIds])

  useEffect(() => {
    setDocumentIds(
      eventData?.coverPhotosIds.length > 0 ? eventData.coverPhotosIds : [],
    )
    setPhotos(eventData?.coverPhotos?.length > 0 ? eventData.coverPhotos : [])
    setDescription(eventData ? eventData.description : undefined)
  }, [])

  return (
    <>
      <div className="w-50p">
        <UploadDocument
          documentIds={documentIds}
          setDocumentIds={setDocumentIds}
          multiple={true}
          docType="image/*"
          files={photos}
          uploadMultipleAtOnce={true}
          coverPhotos={true}
        />
      </div>
      <div className={`${documentIds?.length !== 0 ? 'mt-20px' : ''}`}>
        <label htmlFor="" className="custom-field-label">
          Description
        </label>

        <Input.TextArea
          className="note-field"
          placeholder="Few words about the event"
          value={description}
          autoSize={{ minRows: 5, maxRows: 10 }}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            setDescription(e.target.value)
          }
        />
      </div>
    </>
  )
}

export default CoverAndDescription
